const routerMode = 'history';
const RES_OK = 0;
const baseUrl = 'http://lesson.gyl.ascms.com/';
// const baseUrl = 'http://ltlesson.helixiechuang.com/';
// const baseUrl = process.env.NODE_ENV === 'production' ? 'http://lesson.gyl.ascms.com/' : 'http://ltlesson.helixiechuang.com/';
// const imageBaseUrl = `${baseUrl1}uploads/`;
const imageBaseUrl = `http://lesson.gyl.ascms.com/uploads/`;
const adminBaseUrl = `${baseUrl}api.php/`; // 数据请求接口
const indexBaseUrl = `${baseUrl}index.php/`; // 页面显示接口
const uploadUrl = `${adminBaseUrl}tool/upload?_ajax=1`; // 图片上传
// const domain = "lttalent.helixiechuang.com"
const domain = process.env.NODE_ENV === 'production' ? '.gyl.ascms.com' : 'localhost';
export default {
  baseUrl,
  imageBaseUrl,
  adminBaseUrl,
  routerMode,
  indexBaseUrl,
  uploadUrl,
  RES_OK,
  domain
};
